// PublicFooter — the single canonical marketing-site footer (PRD-171 WP3).
//
// Replaces .landing-footer / .guide-footer / .hiw-footer /
// .upgrade-footer-unified and the bare .footer-inline legal row (which had ZERO
// CSS -- P0-1's twin, leaving the legal pages with unstyled default <p> text and
// no route back to Pricing or the trial). ThankYou gains one too.
//
// Styled entirely from CSS tokens in PublicFooter.css, so it renders correctly
// on all 10 themes with no per-theme override -- same theme story as
// <PublicHeader>, and the reason the themeVariations .landing-footer override is
// deleted rather than re-homed (PRD-171 DELTA-2).
import { Link } from 'react-router-dom';
import './PublicFooter.css';

function PublicFooter() {
  // react-snap runs this at prerender time, baking a static year into the
  // snapshot (same behaviour as the .landing-footer this replaces).
  const year = new Date().getFullYear();

  return (
    <footer className="public-footer">
      <div className="public-footer__content">
        <div className="public-footer__brand-section">
          <span className="public-footer__brand">DriftAlarm</span>
        </div>
        <div className="public-footer__columns">
          <div className="public-footer__column">
            <span className="public-footer__column-title">Product</span>
            <Link to="/upgrade" className="footer-link">Pricing</Link>
            <Link to="/how-it-works" className="footer-link">How It Works</Link>
            <a href="mailto:support@driftalarm.com" className="footer-link">Contact</a>
          </div>
          <div className="public-footer__column">
            <span className="public-footer__column-title">Resources</span>
            <Link to="/guides" className="footer-link">Security Guides</Link>
            <Link to="/guides/attack-surface-monitoring" className="footer-link">Attack Surface Monitoring</Link>
            <Link to="/guides/configuration-drift" className="footer-link">Configuration Drift</Link>
            <Link to="/guides/exposed-rdp" className="footer-link">Exposed RDP Detection</Link>
          </div>
          <div className="public-footer__column">
            <span className="public-footer__column-title">Legal</span>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms" className="footer-link">Terms of Service</Link>
            <Link to="/acceptable-use" className="footer-link">Acceptable Use</Link>
            <Link to="/dpa" className="footer-link">DPA</Link>
          </div>
        </div>
        <div className="public-footer__copyright">
          &copy; {year} DriftAlarm
        </div>
      </div>
    </footer>
  );
}

export default PublicFooter;
